/**
 * Team, as a screen of its own under Internal.
 *
 * The 13 Aug design round put "who has access, and what role they hold" beside
 * Tasks in the new Internal destination. It had lived under Admin since the
 * access list stopped being managed in the Firestore console.
 *
 * This is the same `TeamEditor`; only its address changed. Pipeline stages and
 * email templates stay under Admin — they are settings for the sales process,
 * not a fact about the team, and the design does not place them anywhere.
 *
 * Read-only for non-admins, as it always was. The Firestore rules are the
 * enforcement; this only says so.
 */
import { useAuth } from '@/features/auth/AuthProvider'
import { TeamEditor } from './components/TeamEditor'
import './TeamScreen.css'

export function TeamScreen() {
  const { isAdmin } = useAuth()

  return (
    <main className="teamscreen">
      <div className="teamscreen__head">
        <h2 className="teamscreen__title">Team</h2>
        <p className="teamscreen__sub">
          Who has access, and how they sign their emails.
          {!isAdmin && ' Your account has read-only access to this list.'}
        </p>
      </div>
      <TeamEditor readOnly={!isAdmin} />
    </main>
  )
}
